import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { customModalActions, logout, headerActions } from 'actions';
import { isResponseSuccess } from 'helpers';
import { ContactsApiProvider } from '../../services';
import { bindActionCreators } from 'redux';
import ContentLoader from 'components/common/loaders/ContentLoader';

class SSO extends React.Component {
    static propTypes = {
      logout: PropTypes.func.isRequired,
      match: PropTypes.object,
      history: PropTypes.object.isRequired,
      ssoLogin: PropTypes.func.isRequired
    }

    componentDidMount = async () => {
      const loginResponse = await this.props.ssoLogin(this.props.match.params.ssotoken);

      if (isResponseSuccess(loginResponse)) {
        this.props.history.push('/dashboard');
      } else {
        this.props.logout();
      }
    }

    render () {
      return (
        <React.Fragment>
          <ContentLoader isLoading />
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    userprofile: state.userprofile
  };
};

const mapDispatchToProps = (dispatch) => ({
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  logout: bindActionCreators(logout, dispatch),
  ssoLogin: bindActionCreators(ContactsApiProvider.ssoLogin, dispatch),
  updateCustomModal: bindActionCreators(customModalActions.updateCustomModal, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SSO));
